import { render } from "./PosterEBulletins.vue?vue&type=template&id=2f0399d5"
import script from "./PosterEBulletins.vue?vue&type=script&lang=js"
export * from "./PosterEBulletins.vue?vue&type=script&lang=js"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__